import React, { Component } from 'react';
import {Typography} from '@material-ui/core';
import { AppType } from '../../models/applicazione';
import { useGlobal } from 'reactn';
import { IGlobalState } from '../../states/GlobalState';
import { Principal } from '../../models/principal';

interface Props {
    applicazione: AppType;
    warningDisabled: string | null;
    identity: Principal | null;
}

export default function sidebar(props: Props) {
    
    const getAppName = () => {
        let name = 'ConsultTool';
        if (props.identity?.Company && props.identity?.Company.ApplicationName !== '' && props.identity?.Company.ApplicationName !== null) {
            name = props.identity?.Company.ApplicationName;
        }
        return name;
    }
    switch (props.applicazione) {
        case AppType.IFORFETTARI:
            return  (
            <React.Fragment>
                <Typography variant="h6" style={{fontWeight: 700}}>iForfetari</Typography>
                <br />
                <Typography variant="subtitle1">Utilizzabile per qualsiasi impresa o professione.</Typography>
                <br />
                <Typography variant="subtitle1">Permette la ripetizione istantanea della simulazione a seguito della modifica anche di un solo dato preliminare.</Typography>
                <br />
                <Typography variant="subtitle1">Aggiunge valore alla consulenza "verbale", integrandola con elementi oggettivi.</Typography>
                <br />
                <Typography variant="subtitle1">Consente la precisa illustrazione della situazione personale del cliente.</Typography>
                <div style={{position: 'fixed', bottom: 0, right: 0}}>
                    <Typography variant="subtitle1" >
                        powered by Sixtema S.p.A con socio unico
                    </Typography>
                </div>
            </React.Fragment>
        );

        case AppType.BUDGET4U:
            return (
            <React.Fragment>
                <Typography variant="h6" style={{fontWeight: 700}}>Budget4u</Typography>
                <br />
                <Typography variant="subtitle1">
                Lo strumento consulenziale per analizzare i costi che deve sostenere un'impresa in fase di start up.
                </Typography>
                <br />
                <Typography variant="subtitle1">
                Dall'analisi l'applicazione determina il conto economico presunto con calcoli di imposte, tasse e contributi previdenziali e assistenziali per offrire la stima di Reddito atteso e Reddito netto disponibile
                </Typography>
                <div style={{position: 'fixed', bottom: 0, right: 0}}>
                    <Typography variant="subtitle1">
                        powered by Sixtema S.p.A con socio unico
                    </Typography>
                </div>
            </React.Fragment>
        );

        case AppType.CONVSRL:
            return (
            <React.Fragment>
                <Typography variant="h6" style={{fontWeight: 700}}>Conv Srl</Typography>
                <br />
                <Typography variant="subtitle1">
                L'obiettivo della simulazione è la determinazione del carico fiscale e contributivo complessivo (società e soci) più conveniente rispetto a varie ipotesi.
                </Typography>
                <br />
                <Typography variant="subtitle1">
                A fronte dell'inserimento di alcune informazioni, vengono elaborati gli effetti sulle diverse simulazioni, riepilogando in un ulteriore calcolo finale il confronto tra i diversi carichi fiscali e contributivi.
                </Typography>
                <br />
                <Typography variant="subtitle1">
                Il consulente può così orientare ed eventualmente “bilanciare” le scelte più convenienti per l'impresa.
                </Typography>
                <div style={{position: 'fixed', bottom: 0, right: 0}}>
                    <Typography variant="subtitle1" >
                        powered by Sixtema S.p.A con socio unico
                    </Typography>
                </div>
            </React.Fragment>
        );

        default:
            return (
            <React.Fragment>
                <Typography variant="subtitle1">
                    I cambiamenti digitali in atto impattano sulla professione del consulente in termini di nuove esigenze, tempistiche, performance e qualità del lavoro richiesto.
                </Typography>
                <br />
                <Typography variant="subtitle1">
                    {getAppName()} è la risposta a queste esigenze di cambiamento.
                </Typography>
                <br />
                <Typography variant="subtitle1">
                    Tanti strumenti in un unico ambiente per affrontare la sfida della digital transformation con la massima operatività e semplicità di utilizzo.
                    <h4>Novità aggiornamenti 2026</h4>
                    <h4>Irpef</h4>
                    <p>Tutti i tools sono stati aggiornati in seguito alle novità normative introdotte dal 1/1/ 2026.</p>
                    <p>Gli aggiornamenti hanno riguardato l'aliquota Irpef passata dal 35% al 33% per i redditi compresi tra 28.000 e 50.000 euro.</p>
                    <p>Essi non tengono conto della disposizione di cui al comma 5-bis dell'articolo 16-ter del Tuir, introdotto dalla Legge Finanziaria per il 2026, concernente la revisione della disciplina delle detrazioni fiscali per i contribuenti titolari di un reddito complessivo superiore a 200.000 euro.</p>
                    <p>L'attuale struttura dei tools non ne consente la gestione puntuale.</p>
                    <p>L'applicazione di questa disciplina può comportare, solo per questi contribuenti, un aumento dell'Irpef calcolata fino a 440 euro.</p>
                    <h4>Contribuzione Inps Artigiani, commercianti e Gestione Separata</h4>
                    <p>Tutti i tools sono stati aggiornati secondo le disposizioni valide per l'anno 2026.</p>
                    <h4>Addizionali Regionali all'Irpef</h4>
                    <p>Nei tools “IForfetari” e “Conv srl” sono state aggiornate le aliquote che alcune Regioni hanno modificato per l'anno 2026.</p>
                </Typography>
                {props.warningDisabled !== null ? 
                <>
                <br/>
                <br/>
                <Typography variant="h3" style={{color: 'red'}}>
                    Attenzione. Lo Studio verrà disabilitato in data: {props.warningDisabled} 
                </Typography>
                </>
                : null}
                <div style={{position: 'fixed', bottom: 0, right: 0}}>
                    <Typography variant="subtitle1" >
                        powered by Sixtema S.p.A con socio unico
                    </Typography>
                </div>
            </React.Fragment>
        );
    }
}